import { useEffect } from 'react';

/**
 * Custom hook to set page title dynamically
 * @param {string} pageTitle - The specific page title (e.g., "Dashboard", "History")
 */
export const usePageTitle = (pageTitle: string) => {
  useEffect(() => {
    const fullTitle = `${pageTitle} - Honu Office`;
    document.title = fullTitle;

    // Cleanup: reset to base title when component unmounts
    return () => {
      document.title = 'Honu Office';
    };
  }, [pageTitle]);
};
